import { render, staticRenderFns } from "./signature-contents-publishers.vue?vue&type=template&id=635bbba5&scoped=true&"
import script from "./signature-contents-publishers.ts?vue&type=script&lang=ts&"
export * from "./signature-contents-publishers.ts?vue&type=script&lang=ts&"
import style0 from "./signature-contents-publishers.scss?vue&type=style&index=0&id=635bbba5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635bbba5",
  null
  
)

export default component.exports